/* index.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./index.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useMouseDownEvent } from '../../../../../state/analytics/useLinkClicked';
var styles = null;

/**
 * An anchor component to cover the entire container creating a clickable area.
 * @internal
 * @see `clickableContainer`
 */
var LayeredLink = function LayeredLink(_ref) {
  var onClick = _ref.onClick,
    target = _ref.target,
    testId = _ref.testId,
    text = _ref.text,
    url = _ref.url;
  var onMouseDown = useMouseDownEvent();
  return /*#__PURE__*/React.createElement("a", {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    className: ax(["_1reo15vq _18m915vq _154iidpf _1xi2idpf _94n5idpf _1ltvidpf _azhw1osq _o5721q9c _hboxstnw _obkmidpf _a52dkb7n", "layered-link"]),
    "data-testid": "".concat(testId, "-layered-link"),
    href: url,
    onClick: onClick,
    onMouseDown: onMouseDown,
    target: target,
    tabIndex: -1 // Hide tab index and let the title link be the link.
  }, text);
};
export default LayeredLink;